import store from '@/scripts/store';
import { setToken } from '@/scripts/axios';
import { wsConnection } from '@/scripts/modules/ws';

const catchError = e => {
  store.dispatch('setError', e);

  return Promise.reject(e);
};

const clearAll = () => {
  setToken('');

  wsConnection.reset();

  /*  */
  localStorage.removeItem('token');
  localStorage.removeItem('oauthState');
  localStorage.removeItem('activeGame');

  store.dispatch('clearAll');
};

/*  */
export { catchError, clearAll };
